/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Provision_NotesInputs */

const cs_deals_provision_notes = /** @type {(inputs: Deals_Provision_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznámky k obchodu`)
};

const en_deals_provision_notes = /** @type {(inputs: Deals_Provision_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal notes`)
};

/**
* | output |
* | --- |
* | "Deal notes" |
*
* @param {Deals_Provision_NotesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_provision_notes = /** @type {((inputs?: Deals_Provision_NotesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Provision_NotesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_provision_notes(inputs)
	return cs_deals_provision_notes(inputs)
});